// src/utils/distanceUtils.js - Utilidades para cálculo de distancias

// Coordenadas de la oficina de Climatización Zapata
export const OFICINA_COORDS = {
  lat: 37.86670818025596,
  lng: -0.7939694516834689,
  nombre: "Oficina Climatización Zapata"
};

/**
 * Calcula la distancia entre dos puntos geográficos usando la fórmula de Haversine
 * @param {number} lat1 - Latitud del punto 1
 * @param {number} lng1 - Longitud del punto 1
 * @param {number} lat2 - Latitud del punto 2
 * @param {number} lng2 - Longitud del punto 2
 * @returns {number} - Distancia en kilómetros
 */
export const calcularDistancia = (lat1, lng1, lat2, lng2) => {
  const R = 6371; // Radio de la Tierra en kilómetros
  
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  
  const a = 
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distancia = R * c;
  
  return distancia;
};

/**
 * Convierte grados a radianes
 * @param {number} grados 
 * @returns {number}
 */
const toRad = (grados) => {
  return grados * (Math.PI / 180);
};

/**
 * Calcula la distancia desde la oficina hasta un punto
 * @param {number} lat - Latitud del punto
 * @param {number} lng - Longitud del punto
 * @returns {number} - Distancia en kilómetros
 */
export const calcularDistanciaDesdeOficina = (lat, lng) => {
  if (!lat || !lng) return Infinity; // Si no hay coordenadas, poner al final
  return calcularDistancia(OFICINA_COORDS.lat, OFICINA_COORDS.lng, lat, lng);
};

/**
 * Ordena un array de órdenes por distancia a la oficina (de más lejana a más cercana)
 * @param {Array} ordenes - Array de órdenes con lat y lng
 * @returns {Array} - Array ordenado de órdenes con distancia calculada
 */
export const ordenarOrdenesPorDistancia = (ordenes) => {
  if (!ordenes || ordenes.length === 0) return [];
  
  console.log(`📏 Calculando distancias para ${ordenes.length} órdenes desde oficina (${OFICINA_COORDS.lat}, ${OFICINA_COORDS.lng})`);
  
  // Calcular distancia para cada orden
  const ordenesConDistancia = ordenes.map((orden, index) => {
    const distancia = calcularDistanciaDesdeOficina(orden.lat, orden.lng);
    
    console.log(`📍 Orden original ${index + 1}: ${orden.direccion?.substring(0, 30) || 'Sin dirección'} - Distancia: ${distancia.toFixed(2)} km`);
    
    return {
      ...orden,
      distanciaOficina: distancia,
      ordenOriginal: index + 1 // Guardar el orden original para referencia
    };
  });
  
  // Ordenar de más lejana a más cercana (descendente)
  const ordenesOrdenadas = ordenesConDistancia.sort((a, b) => b.distanciaOficina - a.distanciaOficina);
  
  console.log('✅ Órdenes ordenadas por distancia (de más lejana a más cercana):');
  ordenesOrdenadas.forEach((orden, index) => {
    console.log(`   ${index + 1}. ${orden.direccion?.substring(0, 40) || 'Sin dirección'} - ${orden.distanciaOficina.toFixed(2)} km (era #${orden.ordenOriginal})`);
  });
  
  return ordenesOrdenadas;
};

/**
 * Ordena órdenes por distancia desde un origen dado (ascendente — más cerca primero)
 */
export const ordenarPorDistanciaDesde = (ordenes, origin) => {
  if (!ordenes?.length || !origin?.lat || !origin?.lng) return ordenes;
  return ordenes
    .map(o => ({
      ...o,
      distanciaUsuario: calcularDistancia(origin.lat, origin.lng, o.lat, o.lng),
    }))
    .sort((a, b) => a.distanciaUsuario - b.distanciaUsuario);
};

/**
 * Formatea una distancia para mostrar en UI
 * @param {number} distancia - Distancia en kilómetros
 * @returns {string} - Distancia formateada
 */
export const formatearDistancia = (distancia) => {
  if (distancia === Infinity || isNaN(distancia)) return 'N/A';
  
  if (distancia < 1) {
    return `${Math.round(distancia * 1000)} m`;
  }
  
  return `${distancia.toFixed(1)} km`;
};